import { WebsiteEvents } from './events';
export var PerformanceMetricNameToTypeMap = {
  'Next.js-hydration': WebsiteEvents.WEBSITE_PERFORMANCE_HYDRATION_MEASURED,
  'Next.js-render': WebsiteEvents.WEBSITE_PERFORMANCE_RENDER_MEASURED,
  CLS: WebsiteEvents.WEBSITE_PERFORMANCE_CLS_MEASURED,
  FCP: WebsiteEvents.WEBSITE_PERFORMANCE_FCP_MEASURED,
  FID: WebsiteEvents.WEBSITE_PERFORMANCE_FID_MEASURED,
  INP: WebsiteEvents.WEBSITE_PERFORMANCE_INP_MEASURED,
  LCP: WebsiteEvents.WEBSITE_PERFORMANCE_LCP_MEASURED,
  TTFB: WebsiteEvents.WEBSITE_PERFORMANCE_TTFB_MEASURED,
  TBT: WebsiteEvents.WEBSITE_PERFORMANCE_TBT_MEASURED
};